// Copyright © 2021 Move Closer
export * from './ModalWrapper.contracts';
export * from './ModalWrapper.vue';
